/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionPackageProjectData
 */
export interface SubscriptionPackageProjectData {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPackageProjectData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPackageProjectData
     */
    name?: string;
}

/**
 * Check if a given object implements the SubscriptionPackageProjectData interface.
 */
export function instanceOfSubscriptionPackageProjectData(value: object): value is SubscriptionPackageProjectData {
    return true;
}

export function SubscriptionPackageProjectDataFromJSON(json: any): SubscriptionPackageProjectData {
    return SubscriptionPackageProjectDataFromJSONTyped(json, false);
}

export function SubscriptionPackageProjectDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPackageProjectData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function SubscriptionPackageProjectDataToJSON(json: any): SubscriptionPackageProjectData {
    return SubscriptionPackageProjectDataToJSONTyped(json, false);
}

export function SubscriptionPackageProjectDataToJSONTyped(value?: SubscriptionPackageProjectData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

